<template>
   <div class="proposals-view-v2">
      <ProposalsDashboardV2 />
   </div>
</template>

<script>
import ProposalsDashboardV2 from '@/components/Proposals/ProposalsDashboardV2.vue';

export default {
   name: 'ProposalsDashboardViewV2',
   components: {
      ProposalsDashboardV2,
   },
}
</script>
